module Meevo.Plugins.AlertsManager {

    class SmsHasReachedConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data;

        public percent: number = 50;
        public percents: number[] = [50, 60, 70, 80, 90];

        get dataForReview() {
            return [
                `${this.$translate.instant('LABEL_ALERT_SMS_WHEN_REACHED_PERCENT')} ${this.percent} ${this.$translate.instant('LABEL_ALERT_SMS_WHEN_REACHED')}`
            ];
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: this.percent
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: angular.translate.ITranslateService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: Object): void {
            this.percent = alertJSON[this.data.configKey];
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoSmsHasReachedConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/sms-has-reached-config/sms-has-reached-config.component.html',
            controller: SmsHasReachedConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
